import { gql } from "@edreamsodigeo/frontend-api-client";

const SEND_AUTHENTICATION_EMAIL_MUTATION = gql`
  mutation sendAuthenticationEmail($request: AuthenticationEmailRequest!)
  @silent {
    sendAuthenticationEmail(request: $request) {
      acknowledged
      multiSessionToken
    }
  }
`;

export default SEND_AUTHENTICATION_EMAIL_MUTATION;
